export default "__VITE_ASSET__CSZbjb62__"